import { useEffect, useState } from "react";
import { useAuth } from "../utils/AuthContext";


export const useHospitalManager = () => {
 const [isAdmin, setIsAdmin] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const { user, loading } = useAuth();
  const [isHospitalManager, setIsHospitalManager] = useState(false);
  const [hospitalManagerLoading, setHospitalManagerLoading] = useState(true);

useEffect(() => {
  // console.log("useHospitalManager User:", user);
  if (!loading) {
    if (user) {
      setIsHospitalManager(user.role === "hospital_manager");
      setIsAdmin(user.role === "admin");
      setIsSuperAdmin(user.role === "superadmin");
    } else {
      setIsHospitalManager(false);
      setIsAdmin(false);
      setIsSuperAdmin(false);
    }
    setHospitalManagerLoading(false);
  }
}, [user, loading]);

  return { isHospitalManager, isAdmin, isSuperAdmin, isLoading: loading || hospitalManagerLoading };
};